import React from "react"
import ArrowImg from "../images/arrow.svg"
import { Container, Img } from "./media-nav.styles"

export default ({ value, onClick }) => (
  <Container onClick={onClick} active={value}>
    <Img src={ArrowImg} alt="Arrow" />
  </Container>
)
